import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import List from './List';
import NewRaffle from './NewRaffle';
import EditRaffle from './EditRaffle';

class Container extends Component {
  render() {
    return (
      <div id="raffles">
        <Route exact path="/raffles" component={List} />
        <Route exact path="/raffles/new" component={NewRaffle} />
        <Route exact path="/raffles/:id/edit" component={EditRaffle} />
      </div>
    );
  }
}

export default Container;
